import {BrowserRouter as Router, useLocation} from "react-router-dom";

const { render, createElement  } = wp.element;

function loadComponents(componentsMap) {
    jQuery('[data-ui-component]').each(function() {
        const ChildName = jQuery(this).data('ui-component'); //what component
        let args = jQuery(this).data('args'); //any extra arguments
        const withRouter = jQuery(this).attr('router'); //does it depend on being wrapped in router?
        if (!args) {
            args = {};
        }
        if (componentsMap[ChildName] !== undefined) {
            args.component = ChildName; //pass component name into args, some components (i.e. form based) might use it to identify themselves.
            if (withRouter) {
                render(
                    <Router>

                        {createElement(componentsMap[ChildName], {args:args})}
                    </Router>,
                    jQuery(this)[0]
                );
            } else {
                render(
                    createElement(componentsMap[ChildName], {args:args}),
                    jQuery(this)[0]
                );
            }
        }
    })
}

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function withInstantScroll(doScroll) {
    const html = document.documentElement;
    const body = document.body;

    const prevHtml = html.style.scrollBehavior;
    const prevBody = body.style.scrollBehavior;

    html.style.scrollBehavior = 'auto';
    body.style.scrollBehavior = 'auto';

    try {
        doScroll();
    } finally {
        html.style.scrollBehavior = prevHtml;
        body.style.scrollBehavior = prevBody;
    }
}

export { loadComponents, useQuery, withInstantScroll };